// import { Pagination, PaginationItem } from '@mui/material'
import React from "react";
import styles from "../../styles/pages/home.module.scss";
import styles1 from "../../styles/pages/paginationTwo.module.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import { makeStyles } from '@material-ui/styles';
import { useTheme } from "@mui/material/styles";

// const useStyles = makeStyles((theme) => ({
//   activePage: {
//     backgroundColor: "red",
//     color: "white",
//   },
// }));

const PaginationTwo = ({ page, handleChange, count }) => {
  // const classes = useStyles();
  const theme = useTheme();

  const handlePageChange = (event, newPage) => {
    handleChange(newPage);
  };
  const prevButton = () => {
    return (
      <>
        <ArrowBackIosIcon /> Prev
      </>
    );
  };
  const nextButton = () => {
    return (
      <>
        Next <ArrowForwardIosIcon />
      </>
    );
  };
  return (
      <>
      <Pagination
        count={count}
        page={page}
        onChange={handlePageChange}
        className={`${styles1.paginationTwo} styledPagination`}
        renderItem={(item) => (
          <PaginationItem
            slots={{ previous: prevButton, next: nextButton }}
            {...item}
          />
        )}
       />
    </>
  );
};

export default PaginationTwo;
